import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AboutUs from "./Components/AboutUs/AboutUs";
import Service from "./Components/Service/Service";
import Enquiry from "./Components/Enquiry/Enquiry";
import OurFocus from "./Components/OurFocus/OurFocus";
import GetInTouch from "./Components/GetInTouch/GetInTouch";
import Banner from "./Components/Banner/Banner";
import AboutCompany from "./Pages/AboutCompany/AboutCompany";
import ContactUs from "./Pages/Contact/ContactUs";
import Services from "./Pages/Services/Services";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: (
          <>
            <Banner />
            <AboutUs />
            <Service />
            <Enquiry />
            <OurFocus />
            <GetInTouch />
          </>
        ),
      },
      {
        path: "aboutUs",
        element: <AboutCompany />,
      },
      {
        path: "contactUs",
        element: <ContactUs />,
      },
      {
        path: "services",
        element: <Services />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
